/* tslint:disable */
/* eslint-disable */
/**
 * Yaway API
 * Yaway API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum ApiCountryCode {
    Ee = 'EE',
    Lv = 'LV',
    Lt = 'LT',
    Ru = 'RU'
}

export function ApiCountryCodeFromJSON(json: any): ApiCountryCode {
    return ApiCountryCodeFromJSONTyped(json, false);
}

export function ApiCountryCodeFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiCountryCode {
    return json as ApiCountryCode;
}

export function ApiCountryCodeToJSON(value?: ApiCountryCode | null): any {
    return value as any;
}

